import SCAC from './Tabs/SCAC';
import SCACType from './Tabs/SCACType';
import Facility from './Tabs/Facility';
import FacilityType from './Tabs/FacilityType';
import Store from './Tabs/Store';
import CommodityCode from './Tabs/CommodityCode';
import PO from './Tabs/PO';
import StoreException from './Tabs/StoreException';
import Departments from './Tabs/Departments';
import Vendors from './Tabs/Vendors';
import RoutingGuides from './Tabs/RoutingGuides';
import PreTicket from './Tabs/PreTicket';
import ServiceLevel from './Tabs/ServiceLevel';
import PoSearch from './Tabs/PoSearch';


const renderTabContent = (alignment, tabValue, hasTabs, userRole) => {
    if (!alignment) {
        return <div>Select a dashboard option</div>;
    }

    // Restrict access based on user role
    if (userRole === 'vendor' && alignment !== 'exceptions') {
        return <div>Access Denied</div>;
    }

    // If no tabs are present for the selected toggle button, render the appropriate page
    if (!hasTabs) {
        const noTabsComponentsMapping = {
            'vendors': <Vendors />,
            'routing-guides': <RoutingGuides />,
            'pre-ticket': <PreTicket />
        };

        return noTabsComponentsMapping[alignment];
    }

    // Mapping of alignment and tab index to components for sections with tabs
    const componentsMapping = {
        'codes-and-facilities': {
            0: <SCAC />,
            1: <SCACType />,
            2: <Facility />,
            3: <FacilityType />,
            4: <Store />,
            5: <CommodityCode />,
            6: <ServiceLevel />,
            7: <Departments />
        },
        'exceptions': {
            1: <PO />,
            0: <StoreException />,
            2: <PoSearch />,
        }
    };

    // Return the correct component based on alignment and tab value
    const selectedComponent = componentsMapping[alignment]?.[tabValue];
    console.log("test",selectedComponent);

    // Fallback if no component is found for the selected tab
    return selectedComponent || <div>Component not found</div>;
};

export default renderTabContent;
